import React, { createContext, useReducer } from 'react'
import * as actionType from '../store/actions'
import { CONFIG } from '../config/constant'

const initialState = {
  ...CONFIG,
  isOpen: [], //for active default menu
  isTrigger: [], //for active default menu, set blank for horizontal
}
const ConfigContext = createContext(initialState)
const { Provider } = ConfigContext
const activeUserFontClass = 'font-user-selected'

export const fontFormatOptions = [
  { label: 'Default', value: 'font-default' },
  { label: 'Prompt', value: 'font-prompt' },
  { label: 'K2D', value: 'font-k2d' },
  { label: 'Angsana', value: 'font-angsana' },
  { label: 'Sarabun', value: 'font-sarabun' },
  { label: 'Sarabun New', value: 'font-sarabun-new' },
]

const ConfigProvider = ({ children }) => {
  let trigger = []
  let open = []

  const applyFont = (fontName) => {
    fontFormatOptions.forEach(({ value }) => {
      document.body.classList.remove(value)
    })
    document.body.classList.remove(activeUserFontClass)

    if (fontName !== 'font-default') {
      document.body.classList.add(fontName, activeUserFontClass)
    }
    localStorage.setItem('userFontFormat', fontName)
  }

  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case actionType.BOX_LAYOUT:
        return {
          ...state,
          boxLayout: !state.boxLayout,
        }
      case actionType.CHANGE_LAYOUT:
        return {
          ...state,
          layout: action.layout,
        }
      case actionType.CHANGE_SUB_LAYOUT:
        return {
          ...state,
          subLayout: action.subLayout,
        }
      case actionType.COLLAPSE_MENU:
        return {
          ...state,
          collapseMenu: !state.collapseMenu,
        }
      case actionType.COLLAPSE_TOGGLE:
        if (action.menu.type === 'sub') {
          open = state.isOpen
          trigger = state.isTrigger

          const triggerIndex = trigger.indexOf(action.menu.id)
          if (triggerIndex > -1) {
            open = open.filter((item) => item !== action.menu.id)
            trigger = trigger.filter((item) => item !== action.menu.id)
          }

          if (triggerIndex === -1) {
            open = [...open, action.menu.id]
            trigger = [...trigger, action.menu.id]
          }
        } else {
          open = state.isOpen
          const triggerIndex = state.isTrigger.indexOf(action.menu.id)
          trigger = triggerIndex === -1 ? [action.menu.id] : []
          open = triggerIndex === -1 ? [action.menu.id] : []
        }

        return {
          ...state,
          isOpen: open,
          isTrigger: trigger,
        }
      case actionType.HEADER_BACK_COLOR:
        return {
          ...state,
          headerBackColor: action.headerBackColor,
        }
      case actionType.HEADER_FIXED_LAYOUT:
        return {
          ...state,
          headerFixedLayout: !state.headerFixedLayout,
          headerBackColor:
            !state.headerFixedLayout && initialState.headerBackColor === ''
              ? 'header-blue'
              : state.headerBackColor,
        }
      case actionType.LAYOUT_TYPE:
        return {
          ...state,
          layoutType: action.layoutType,
          headerBackColor: initialState.headerBackColor,
        }
      case actionType.NAV_COLLAPSE_LEAVE:
        if (action.menu.type === 'sub') {
          open = state.isOpen
          trigger = state.isTrigger

          const triggerIndex = trigger.indexOf(action.menu.id)
          if (triggerIndex > -1) {
            open = open.filter((item) => item !== action.menu.id)
            trigger = trigger.filter((item) => item !== action.menu.id)
          }
          return {
            ...state,
            isOpen: open,
            isTrigger: trigger,
          }
        }
        return { ...state }
      case actionType.NAV_CONTENT_LEAVE:
        return {
          ...state,
          isOpen: open,
          isTrigger: trigger,
        }
      case actionType.NAV_FIXED_LAYOUT:
        return {
          ...state,
          navFixedLayout: !state.navFixedLayout,
        }
      case actionType.RTL_LAYOUT:
        return {
          ...state,
          rtlLayout: !state.rtlLayout,
        }
      case actionType.RESET:
        return {
          ...state,
          layout: initialState.layout,
          subLayout: initialState.subLayout,
          collapseMenu: initialState.collapseMenu,
          layoutType: initialState.layoutType,
          headerBackColor: initialState.headerBackColor,
          rtlLayout: initialState.rtlLayout,
          navFixedLayout: initialState.navFixedLayout,
          headerFixedLayout: initialState.headerFixedLayout,
          boxLayout: initialState.boxLayout,
        }
      case actionType.USER_THEME: {
        const userTheme = { ...(action.userTheme || {}) }
        delete userTheme.collapseMenu
        return {
          ...state,
          ...userTheme,
        }
      }
      case actionType.USER_FONT: {
        //debugger
        applyFont(action.userFont)
        return {
          ...state,
          ...action.userFont,
        }
      }
      case actionType.SWITCH_PATIENT_DEPARTMENT:
        return {
          ...state,
          patientMenu: action.patientMenu,
        }
      case actionType.PERSPECTIVE:
        return {
          ...state,
          perspective: action.perspective,
        }
      case actionType.PERSPECTIVE_MENU:
        return {
          ...state,
          perspectiveMenu: action.perspectiveMenu,
        }
      case actionType.GROUP_MENU_ID:
        return {
          ...state,
          groupMenuId: action.groupMenuId,
        }
      case actionType.MENU_CLICK:
        return {
          ...state,
          menuClick: action.menuClick,
        }
      case actionType.COLLAPSE_CLICK:
        localStorage.setItem('currentCollapse', action?.collapseClick?.id)
        return {
          ...state,
          collapseClick: action.collapseClick,
        }
      case actionType.DESIGN_NAME:
        return {
          ...state,
          designName: action.designName,
        }
      default:
        throw new Error()
    }
  }, initialState)

  return <Provider value={{ state, dispatch }}>{children}</Provider>
}

export { ConfigContext, ConfigProvider }
